export default __webpack_public_path__ + "static/media/vlcsnap-2021-10-19-09h04m32s685.ddf2fc95.jpg";